import {DatevWizardClientIdState} from './datev-wizard-client-id.state';


export const datevWizardClientIdStateInitial: DatevWizardClientIdState = {
  clientId: undefined,
  existingExportConfig: undefined,
  existingExportConfigStatus: undefined,
  checkConfigLoading: [],
  checkConfigLoaded: [],
  existingExportConfigLoading: [],
  existingExportConfigLoaded: [],
  existingExportConfigStatusLoading: [],
  existingExportConfigStatusLoaded: [],
  existingExportConfigStatusError: false,
  existingExportConfigError: false,
  existingExportConfigErrorStatus: undefined,
  existingExportConfigExists: false,
  checkConfigSuccessLoginUrl: undefined,
};
